/**
 * Stockage des réponses de vote pour relay vers l’inscription (lucien-form-builder).
 * Étapes 1–5 → champs question_46 … question_50 côté formulaire.
 */

export const QUIZ_VOTES_STORAGE_KEY = "op-biscuit-ferrero-quiz-votes";

/** @param {number} step Entier 1 à 5 */
export function questionKeyForQuizStep(step) {
  return `question_${45 + step}`;
}

export function readQuizVotesMap() {
  try {
    const raw = sessionStorage.getItem(QUIZ_VOTES_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function writeQuizVotesMap(map) {
  sessionStorage.setItem(QUIZ_VOTES_STORAGE_KEY, JSON.stringify(map));
}

/** @param {number} step 1–5 */
export function getQuizVote(step) {
  const key = questionKeyForQuizStep(step);
  const v = readQuizVotesMap()[key];
  if (v == null || v === "") return null;
  return String(v);
}

/** @param {number} step 1–5 @param {string} productId */
export function setQuizVote(step, productId) {
  const key = questionKeyForQuizStep(step);
  const map = readQuizVotesMap();
  map[key] = productId;
  writeQuizVotesMap(map);
}

/** Objet `relay` pour `<Form :relay="…" />` : clés présentes seulement si le vote existe. */
export function buildQuizVotesRelay() {
  const map = readQuizVotesMap();
  const relay = {};
  for (let s = 1; s <= 5; s++) {
    const k = questionKeyForQuizStep(s);
    const val = map[k];
    if (val != null && val !== "") {
      relay[k] = val;
    }
  }
  return relay;
}

export function clearQuizVotes() {
  try {
    sessionStorage.removeItem(QUIZ_VOTES_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

const QUIZ_STEPS_COUNT = 5;

function isNonEmptyVoteValue(value) {
  return value != null && String(value).trim() !== "";
}

/** Votes présents dans les paramètres GET (question_46 … question_50). */
export function readQuizVotesFromQuery(query = {}) {
  const relay = {};
  for (let s = 1; s <= QUIZ_STEPS_COUNT; s++) {
    const key = questionKeyForQuizStep(s);
    const val = query[key];
    if (isNonEmptyVoteValue(val)) {
      relay[key] = String(val);
    }
  }
  return relay;
}

/** Fusionne les votes GET en sessionStorage (comme first_name sur /form). */
export function syncQuizVotesFromQuery(query = {}) {
  const fromQuery = readQuizVotesFromQuery(query);
  if (Object.keys(fromQuery).length === 0) return;

  const map = readQuizVotesMap();
  let changed = false;
  for (const [key, val] of Object.entries(fromQuery)) {
    if (map[key] !== val) {
      map[key] = val;
      changed = true;
    }
  }
  if (changed) {
    writeQuizVotesMap(map);
  }
}

/** Questionnaire complet : 5 votes en session ou en GET. */
export function hasCompletedQuizVotes(query = {}) {
  const fromQuery = readQuizVotesFromQuery(query);
  if (Object.keys(fromQuery).length === QUIZ_STEPS_COUNT) {
    return true;
  }

  for (let s = 1; s <= QUIZ_STEPS_COUNT; s++) {
    if (!getQuizVote(s)) return false;
  }
  return true;
}
